export default "__VITE_ASSET__f03c766f__"